import { tzAxios } from 'api/axios';
import { ConcertResponse, MatchResponse } from 'api/responseTypes';

export const getEventInfo = async (id: string) =>
  (await tzAxios.get<MatchResponse & ConcertResponse>(`/ticket-zone/event/event/${id}/info`)).data;
